import cn from 'classnames'
import { useRouter } from 'next/router'

import { ToggleSwitch } from '@components/ToggleSwitch'
import { useDropdown } from '@hooks/useDropdown'
import { ArrowLeftIcon } from '@components/icons/ArrowLeftIcon'
import { EditIcon } from '@components/icons/EditIcon'
import { MenuIcon } from '@components/icons/MenuIcon'
import { MenuBarProps } from './interface'

export function MenuBar({
  title,
  myWritingOptions,
  isEnded,
  handleFetchNextPage,
  handleManageWriting,
  handleEditWriting,
  handleManageChapter,
  handleToggleIsEnded,
  previousPage,
}: MenuBarProps) {
  const { dropdownRef, isShowDropdown, toggleDropdown } = useDropdown()
  const { push } = useRouter()

  return (
    <>
      <section className='flex sticky top-[60px] z-20 items-center bg-white dark:bg-dark-8 shadow-dropdown w-full desktop-tablet:px-[20px] py-[10px] mobile:flex-wrap mobile:justify-center'>
        <button
          type='button'
          className='desktop:hidden border-[1px] mr-[20px] border-gray-3 dark:border-dark-10 w-[40px] h-[40px] p-[8px] bg-white dark:bg-dark-9 rounded-full'
          onClick={previousPage}
        >
          <ArrowLeftIcon className='w-[24px] h-[24px] text-secondary dark:text-dark-10' />
        </button>
        <button
          type='button'
          className='flex justify-center items-center my-[10px] mr-[20px]  rounded-[20px] bg-primary dark:bg-purple shrink-0 w-[121px] h-[40px] mobile:w-[133px]'
          onClick={handleManageWriting}
        >
          <span className='text-[14px] font-mitr font-medium text-white dark:text-white-2 whitespace-nowrap'>
            จัดการงานเขียน
          </span>
        </button>
        <div ref={dropdownRef} className='mobile:order-4 my-[10px] mr-[20px]'>
          <button
            className={cn(
              'flex text-sm bg-gray-4 dark:bg-transparent dark:border dark:border-dark-10 text-secondary dark:text-dark-10 whitespace-nowrap items-center px-[20px] h-[40px] rounded-[20px] font-mitr font-medium'
            )}
            type='button'
            onClick={toggleDropdown}
          >
            <MenuIcon width='24' height='24' className='mr-[10px]' />
            เลือกเรื่อง
          </button>

          <div
            className={cn(
              'bg-white dark:bg-dark-9 border-gray-4 dark:border-purple max-h-[350px] overflow-y-auto fixed top-[120px] left-[160px] py-2.5 w-[269px] z-10 rounded-[10px] shadow border tablet:left-[220px] mobile:w-full mobile:!left-0 mobile:top-[180px]',
              { hidden: !isShowDropdown }
            )}
            onScroll={(e: any) => {
              const scrollHeight = e.target.scrollHeight - 10
              const scrollTop = e.target.scrollTop + e.target.offsetHeight
              if (scrollHeight <= scrollTop) {
                handleFetchNextPage()
              }
            }}
          >
            {myWritingOptions?.map(option => (
              <div className='max-h-[310px] overflow-y-auto' key={option.value}>
                <div
                  className={cn(
                    'px-[25px] py-[8.5px] text-sm font-light truncate break-word text-left text-secondary dark:text-dark-10 hover:text-primary dark:hover:text-dark-10 hover:bg-blue-2 dark:hover:bg-dark cursor-pointer'
                  )}
                  onClick={() => {
                    toggleDropdown()
                    push(`/my-writing/${option.value}`)
                  }}
                >
                  {option.label}
                </div>
              </div>
            ))}
          </div>
        </div>
        {title && (
          <span className='font-light text-[14px] truncate ml-[18px] tablet-mobile:hidden dark:text-white-2'>
            เรื่อง {title}
          </span>
        )}
        <div className='desktop-tablet:flex-1' />
        <button
          type='button'
          className='shrink-0 flex items-center justify-center mr-[20px] space-x-[5px] bg-primary dark:bg-purple rounded-[20px] w-[95px] h-[40px] mobile:w-[40px] mobile:order-5'
          onClick={handleEditWriting}
        >
          <EditIcon
            className='text-white dark:text-white-2'
            width='20'
            height='20'
          />
          <span className='font-mitr text-[14px] font-medium text-white dark:text-white-2 mobile:hidden'>
            แก้ไข
          </span>
        </button>

        <button
          type='button'
          className='bg-white dark:bg-transparent border border-primary dark:border-dark-10 my-[10px] mr-[20px] w-[94px] h-[40px] rounded-[20px] shrink-0 mobile:order-6 mobile:w-[135px]'
          onClick={handleManageChapter}
        >
          <span className='text-[14px] font-medium font-mitr text-primary dark:text-dark-10 whitespace-nowrap'>
            จัดการตอน
          </span>
        </button>

        <div className='bg-white dark:bg-transparent border mobile:mr-[20px] border-gray-3 dark:border-dark-10 rounded-[20px] flex space-x-[10px] items-center justify-center w-[127px] h-[40px] shrink-0 mobile:w-[134px]'>
          <p className='text-primary dark:text-dark-10 font-light text-[14px]'>
            จบแล้ว
          </p>
          <ToggleSwitch checked={!!isEnded} onChange={handleToggleIsEnded} />
        </div>
      </section>
    </>
  )
}
